import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, XCircle } from "lucide-react";
import PublicHeader from "@/components/layout/PublicHeader";

/* eslint-disable react/no-unescaped-entities */

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, email: "" });
  useEffect(() => {
    document.title = "Unsubscribe · Central Rentals Canada";
    if (!token) { setState({ loading: false, ok: false, email: "" }); return; }
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${API_BASE}/api/newsletter/unsubscribe?token=${encodeURIComponent(token)}`);
        const d = r.ok ? await r.json() : { ok: false };
        if (!cancelled) setState({ loading: false, ok: !!d.ok, email: d.email || "" });
      } catch {
        if (!cancelled) setState({ loading: false, ok: false, email: "" });
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <PublicHeader light={true}/>
      <main className="max-w-xl mx-auto px-5 md:px-8 py-20 text-center" data-testid="unsubscribe-page">
        {state.loading ? (
          <p className="text-slate-500">Processing your request…</p>
        ) : state.ok ? (
          <>
            <div className="w-14 h-14 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center mx-auto mb-5">
              <CheckCircle className="w-7 h-7"/>
            </div>
            <h1 className="font-display text-3xl font-extrabold tracking-tighter text-slate-900">You're unsubscribed.</h1>
            <p className="mt-3 text-slate-600">{state.email ? <>We won't send any more marketing emails to <b>{state.email}</b>.</> : "We won't send any more marketing emails to this address."}</p>
            <p className="mt-2 text-sm text-slate-500">Transactional emails (rent receipts, password resets, applications) are not affected.</p>
            <Link to="/" className="mt-7 inline-block px-6 py-3 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold">Back to centralrentals.ca</Link>
          </>
        ) : (
          <>
            <div className="w-14 h-14 rounded-full bg-rose-100 text-rose-700 flex items-center justify-center mx-auto mb-5">
              <XCircle className="w-7 h-7"/>
            </div>
            <h1 className="font-display text-3xl font-extrabold tracking-tighter text-slate-900">Subscription not found.</h1>
            <p className="mt-3 text-slate-600">Your link may have expired or you're already unsubscribed. If you continue to get unwanted emails, write to <a href="mailto:contact@centralrentals.ca" className="text-emerald-700 underline">contact@centralrentals.ca</a> and we'll remove you manually.</p>
            <Link to="/" className="mt-7 inline-block px-6 py-3 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-900 font-bold">Back to centralrentals.ca</Link>
          </>
        )}
      </main>
    </div>
  );
}
